import * as React from 'react';
import styled from 'styled-components';

interface ILogoProps {
    logo: {
        imageUrl: string,
        alt: string
    };
    theme?: {
        content: {
            header_background: string
        }
    };
    hidePadding?: boolean;
}

interface ILogoWrapperProps {
    hidePadding?: boolean;
    theme?: {
        content: {
            header_background: string
        }
    }
}

interface ILogoTheme {
    theme: {
        content: {
            header_background: string
        }
    }
}
const LogoWrapper = styled<ILogoWrapperProps, 'div'>('div')`
    height: 100px;
    padding-top: ${(props: {hidePadding?: boolean}) => props.hidePadding ? '0px' : '30px'};
    display: flex;
    justify-content: center;
    background: ${(props: ILogoTheme) => props.theme && props.theme.content && props.theme.content.header_background};

    @media (max-width: 550px) {
        height: 50px;
    }
`

const Logo = styled.img`
    margin: 0 auto;
    object-fit: contain;
    height: 35px;
    width: 190px;
    @media (max-width: 768px) {
        padding-top: 8px;
    }
    @media (min-width: 768px) {
        padding-top: 32px;
    }
`

const LogoComponent = (props: ILogoProps) => {
    return (
        <LogoWrapper theme={props.theme} hidePadding={props.hidePadding}>
            <Logo src={props.logo && props.logo.imageUrl} alt={props.logo && props.logo.alt} />
        </LogoWrapper>
    )
}

export default LogoComponent



// WEBPACK FOOTER //
// ./src/components/LogoComponent.tsx